export default __webpack_public_path__ + "static/media/claas-axion.0f619a49.png";